import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatDate, formatDateTime } from 'utils/Formatters';
import { find, isEmpty, map, groupBy } from 'lodash';

class GroupCohortsReportDetailsModal extends React.Component {
  render() {
    const {report} = this.props;

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>Report Details</b></h2>
        <hr className='u-margin-top--zero'/>
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>Requested at</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
            <tr>
              <th>Groups</th>
              <td>{this.renderRelated('groups')}</td>
            </tr>
            <tr>
              <th>With cohorts</th>
              <td>{report.params.withcohorts ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <th>With age ranges</th>
              <td>{report.params.withages ? 'Yes' : 'No'}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRelated(related) {
    const collection = this.props[related];

    return this.relatedIds(related).map((id) => {
      return find(collection, p => p.value == id).label;
    }).join(', ');
  }

  relatedIds(relatedAttribute) {
    const {report} = this.props;

    if (isEmpty(report.params[relatedAttribute])) { return []; }

    return report.params[relatedAttribute].split(',').map((id) => {
      return parseInt(id, 10);
    });
  }
}

const mapStateToProps = (state) => {
  return {
    groups: state.filters.groups,
  };
}

GroupCohortsReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect(mapStateToProps, null)(GroupCohortsReportDetailsModal);
